import React, { useState } from 'react';
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Select from 'react-select';

const reportTypes = [
  { value: 'delivery-card-report', label: 'Delivery Card Report' },
  { value: 'production-sheet-report', label: 'Production Sheet Report' },
  { value: 'pos', label: 'POs' },
];
export const GenerateReportsModal = ({ isOpen, toggle, token, merchantId }) => {
  const [date, setDate] = useState('');
  const [reportType, setReportType] = useState(null);
  const isSubmitDisabled = !date || !reportType;
  const onSubmit = async (e) => {
    e.preventDefault();
    
    if (reportType?.value === 'pos') {
      // Handle POs report with POST request
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/dashboard/admin/v1/merchants/${merchantId}/generate-full-day-pos`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
              date: date,
            }),
          }
        );
        
        if (response.ok) {
          // Handle successful response - you might want to show a success message
          console.log('POs report generated successfully');
        } else {
          // Handle error response
          console.error('Failed to generate POs report');
        }
      } catch (error) {
        console.error('Error generating POs report:', error);
      }
    } else {
      // Handle other reports with GET request (existing behavior)
      window.open(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard/admin/v1/merchants/${merchantId}/${reportType?.value}?token=${token}&delivery_date=${date}`,
        '_blank',
      );
    }
    
    toggle();
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Generate report</ModalHeader>
      <ModalBody>
        <div>
          <Label>Select Report type</Label>
          <Select
            options={reportTypes}
            placeholder={'Select Report Type'}
            onChange={setReportType}
          />
        </div>
        <div className='m--margin-top-20'>
          <Label>Select Date</Label>
          <Input type='date' onChange={(e) => setDate(e.target.value)} />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color='primary' onClick={onSubmit} disabled={isSubmitDisabled}>
          Generate
        </Button>
        <Button color='secondary' onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};
